import { StoreDispatch } from 'Store';
import * as Edge from 'Edge/Data';
import * as BLE from 'BLE';

export function makeCollector(
  dispatch: StoreDispatch,
  ble: BLE.Service,
  deviceType: Edge.DeviceType,
  device: Edge.UserDevice
): Edge.Collector {
  if (deviceType.protocol !== undefined) {
    const makeCollector =
      require(`Edge/Collector/${BLE.assertProtocol(deviceType.protocol)}`).makeCollector;
    return makeCollector(dispatch, ble, deviceType, device);
  } else {
    throw new Error('Can not construct collector from undefined protocol');
  }
}
